var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationPinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location"
  }, /*#__PURE__*/React.createElement("path", {
    id: " \xE2\x86\xB3Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9998 2.16666C8.80734 2.16666 5.4165 5.55749 5.4165 9.74999C5.4165 15.4375 12.9998 23.8333 12.9998 23.8333C12.9998 23.8333 20.5832 15.4375 20.5832 9.74999C20.5832 5.55749 17.1923 2.16666 12.9998 2.16666ZM12.9998 12.4583C11.5048 12.4583 10.2915 11.245 10.2915 9.74999C10.2915 8.25499 11.5048 7.04166 12.9998 7.04166C14.4948 7.04166 15.7082 8.25499 15.7082 9.74999C15.7082 11.245 14.4948 12.4583 12.9998 12.4583Z",
    fill: "current"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinIcon);
export default __webpack_public_path__ + "static/media/location-pin-icon.e6ff0402e72a56a291f5f9ab35f5dc0b.svg";
export { ForwardRef as ReactComponent };